module.exports = __webpack_public_path__ + "media/components/country-flag/static/dm-da5346401699ac7a72a2c509e2be72f0.svg";